const NO_ERROR = null;
const FIELD_REQUIRED = 'translate.validations.required';
const FIELD_HAS_ONLY_SPACES = 'translate.validations.field.cant.have.only.spaces';

const isFieldEmpty = (value) => value === undefined || value === null || value === '';

const hasOnlySpaces = (value) => (value.replace(/\s/g, '').length === 0);

export const genericFieldValidation = (value) => {
  if (isFieldEmpty(value)) {
    return FIELD_REQUIRED;
  }

  if (hasOnlySpaces(value)) {
    return FIELD_HAS_ONLY_SPACES;
  }

  return NO_ERROR;
};
